import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl, defineMessages } from 'react-intl';
import { Button } from 'primereact/button';
import { Panel } from 'primereact/panel';
import { Dropdown } from 'primereact/dropdown';
import _ from 'lodash';
import { intlShape, growlShape } from '../../../../../components/prop-types';

import HintsHeader from './HintsHeader';
import ArrayUtil from '../../../../../utils/ArrayUtil';
import { Loading } from '../../../../../components/Loading';
import { getStandardJob, updateJobProfileStandJob } from '../../../../../services/apps/JobProfileService';
import { growlErrors, growlActionSuccess } from '../../../../../utils/NotificationUtil';
import { withAccount } from '../../../../../components/AccountContext';
import { withGrowl } from '../../../../../components/GrowlNotifications';

const i18n = defineMessages({
  industryPlaceholder: {
    id: 'choose.category',
    defaultMessage: 'Choose category',
  },
  jobProfilePlaceholder: {
    id: 'choose.job',
    defaultMessage: 'Choose job profile',
  },
  searchJobPlaceholder: {
    id: 'choose.typeToSearch',
    defaultMessage: 'Type to search',
  },
  jobTitle: {
    id: 'choose.jobTitle',
    defaultMessage: 'Job Title',
  },
  domain: {
    id: 'choose.domain',
    defaultMessage: 'Domain',
  },
  save: {
    id: 'actions.save',
    defaultMessage: 'Save',
  },
  successNoti: {
    id: 'noti.success',
    defaultMessage: 'Success!',
  },
  clear: {
    id: 'actions.clear',
    defaultMessage: 'Clear',
  },
});

class HintsSJL extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isShowHint: false,
      jobprofileValue: null,
      standardJobs: [],
      selectedStandardJob: null,
      industryId: null,
    };

    this.handleHints = this.handleHints.bind(this);
    this.handleShowHints = this.handleShowHints.bind(this);
    this.handleChooseJobProfile = this.handleChooseJobProfile.bind(this);
    this.handleChooseCategory = this.handleChooseCategory.bind(this);
    this.saveStandardJob = this.saveStandardJob.bind(this);
    this.clearStandardJob = this.clearStandardJob.bind(this);
  }

  componentDidMount() {
    const { jobProfile: { standardJob }, onHints } = this.props;
    if (standardJob) {
      this.setState({
        industryId: standardJob.industryId,
        jobprofileValue: standardJob.id,
        selectedStandardJob: standardJob.id,
        isShowHint: true,
      });
      onHints(true, standardJob.id);
    }
    this.loadStandardJob();
  }

  async loadStandardJob() {
    const { onActionFailed } = this.props;
    try {
      const data = await getStandardJob();
      this.setState({
        standardJobs: data,
      });
    } catch (err) {
      onActionFailed(err);
    }
  }

  async saveStandardJob() {
    const {
      jobProfile, currentAccount, growl, intl: { formatMessage },
    } = this.props;
    const { jobprofileValue } = this.state;
    try {
      await updateJobProfileStandJob({
        jobProfileId: jobProfile.id,
        accountId: currentAccount,
        standardJobProfileNumber: jobprofileValue,
      });
      growlActionSuccess(growl, formatMessage(i18n.successNoti));
    } catch (errors) {
      growlErrors(growl, errors);
    }
  }

  clearStandardJob() {
    const { onHints } = this.props;
    const { jobprofileValue } = this.state;
    onHints(false, jobprofileValue);
    this.setState({
      industryId: null,
      jobprofileValue: null,
      selectedStandardJob: null,
    });
  }

  handleChooseJobProfile(item) {
    const {
      onHints,
    } = this.props;
    const { standardJobs } = this.state;
    const selectedJob = standardJobs.find(job => (item.value === job.id));
    this.setState({ isShowHint: true });
    onHints(true, item.value);
    this.setState({
      jobprofileValue: item.value,
      industryId: selectedJob ? selectedJob.industryId : '',
      selectedStandardJob: item.value,
    });
  }

  handleHints() {
    const { onHints } = this.props;
    const { isShowHint, jobprofileValue } = this.state;
    if (jobprofileValue != null) {
      const isShowHintNew = !isShowHint;
      this.setState({ isShowHint: isShowHintNew });
      onHints(isShowHintNew, jobprofileValue);
    }
  }

  handleShowHints(event) {
    const { onHints } = this.props;
    this.setState({ isShowHint: true });
    onHints(true, event.value);
    this.setState({ jobprofileValue: event.value });
  }

  handleChooseCategory(event) {
    const { onHints } = this.props;
    const { jobprofileValue } = this.state;
    if (jobprofileValue) {
      this.setState({ isShowHint: false });
      onHints(false, jobprofileValue);
      this.setState({ jobprofileValue: null });
    }

    this.setState({ industryId: event.value });
  }

  render() {
    const { intl: { formatMessage } } = this.props;
    const {
      standardJobs, isShowHint,
      selectedStandardJob, industryId,
      jobprofileValue,
    } = this.state;
    if (ArrayUtil.isEmpty(standardJobs)) {
      return <Loading />;
    }

    const saveText = formatMessage(i18n.save);
    const clearText = formatMessage(i18n.clear);

    let industries = standardJobs.map(s => ({ id: s.industryId, name: s.industryName }));
    industries = _.uniqBy(industries, industry => industry.id);
    industries = _.sortBy(industries, industry => industry.name);
    const industriesForDropDown = _.sortBy(
      industries.map(ind => ({
        ...ind,
        key: ind.id,
        value: ind.id,
        label: ind.name,
      })), ind => ind.name,
    );

    const industryJobProfiles = _.filter(standardJobs, standardJob => standardJob.industryId === industryId);
    const industryJobProfilesSorted = _.sortBy(industryJobProfiles, jobProfile => jobProfile.name);
    const industryJobProfilesForDropDown = _.sortBy(
      industryJobProfilesSorted.map(job => ({
        ...job,
        key: job.id,
        value: job.id,
        label: job.name,
      })), job => job.name,
    );

    const standardJobsForDropDown = _.sortBy(standardJobs, standardJob => standardJob.name)
      .map(standardJob => ({
        ...standardJob,
        key: standardJob.id,
        value: standardJob.id,
        label: standardJob.name,
      }));

    return (
      <Panel
        className="panel-SJL"
        header={(
          <HintsHeader onHints={this.handleHints} isShow={isShowHint}>
            <FormattedMessage id="SJL" defaultMessage="Job Profile Library" />
          </HintsHeader>
        )}
      >
        <div className="p-grid">
          <div className="p-col-12">
            <div className="p-grid p-fluid">
              <div className="p-col-12">
                <Dropdown
                  options={standardJobsForDropDown}
                  onChange={this.handleChooseJobProfile}
                  placeholder={`- ${formatMessage(i18n.jobTitle)} -`}
                  value={selectedStandardJob}
                  filter
                />
              </div>
            </div>
            <div className="p-grid p-fluid">
              <div className="p-col-12">
                <Dropdown
                  options={industriesForDropDown}
                  onChange={this.handleChooseCategory}
                  placeholder={`- ${formatMessage(i18n.domain)} -`}
                  value={industryId}
                  filter
                />
              </div>
            </div>
            <div className="p-grid p-fluid">
              <div className="p-col-12">
                {ArrayUtil.isNotEmpty(industryJobProfilesSorted) && (
                  <Dropdown
                    options={industryJobProfilesForDropDown}
                    onChange={this.handleShowHints}
                    placeholder={`- ${formatMessage(i18n.searchJobPlaceholder)} -`}
                    value={jobprofileValue}
                    filter
                  />
                )}
              </div>
            </div>
            <div className="p-grid">
              <div className="p-col-12">
                <Button
                  type="button"
                  label={saveText}
                  onClick={this.saveStandardJob}
                />
                <Button
                  type="button"
                  label={clearText}
                  onClick={this.clearStandardJob}
                  className="p-button-warning"
                  disabled={!(selectedStandardJob || industryId || jobprofileValue)}
                />
              </div>
            </div>
          </div>
        </div>
      </Panel>
    );
  }
}

HintsSJL.propTypes = {
  onActionFailed: PropTypes.func.isRequired,
  onHints: PropTypes.func.isRequired,
  intl: intlShape.isRequired,
  jobProfile: PropTypes.objectOf(PropTypes.any).isRequired,
  currentAccount: PropTypes.string.isRequired,
  growl: growlShape.isRequired,
};

export default withGrowl(
  withAccount(
    injectIntl(
      HintsSJL,
    ),
  ),
);
